import { render, staticRenderFns } from "./headTip.vue?vue&type=template&id=3990f0c7&scoped=true&"
import script from "./headTip.vue?vue&type=script&lang=js&"
export * from "./headTip.vue?vue&type=script&lang=js&"
import style0 from "./headTip.vue?vue&type=style&index=0&id=3990f0c7&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3990f0c7",
  null
  
)

export default component.exports